import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for the four inventory reports.
 *
 * It renders nothing of its own - each report is a full page - but it has to
 * exist so `/inventory` and `/inventory/summary` nest rather than collide.
 * The movement ledger lives in the index child.
 */
export const Route = createFileRoute('/_app/inventory')({
  component: Outlet,
});
